import { z } from 'zod';
import {
  ApiPath,
  adminAkunListItemSchema,
  type AdminAkunResetPasswordRequest,
  type AdminAkunUnlockRequest,
  type AdminAkunDeactivateRequest,
} from '@app/shared';
import { apiList, apiPost } from '../../lib/api';

export async function getAdminAkunList(params?: {
  page?: number;
  limit?: number;
  search?: string;
  status_akun?: 'aktif' | 'nonaktif' | 'terkunci';
  role?: string;
  sort_by?: string;
  sort_dir?: 'asc' | 'desc';
}) {
  return apiList(ApiPath.ADMIN.AKUN, adminAkunListItemSchema, params);
}

export async function resetAkunPassword(id: number, body: AdminAkunResetPasswordRequest) {
  return apiPost(ApiPath.ADMIN.RESET_PASSWORD(id), body, adminAkunListItemSchema);
}

export async function unlockAkun(id: number, body: AdminAkunUnlockRequest) {
  return apiPost(ApiPath.ADMIN.UNLOCK(id), body, adminAkunListItemSchema);
}

export async function deactivateAkun(id: number, body: AdminAkunDeactivateRequest) {
  return apiPost(ApiPath.ADMIN.DEACTIVATE(id), body, z.null());
}

export async function reactivateAkun(id: number) {
  return apiPost(ApiPath.ADMIN.REACTIVATE(id), {}, z.null());
}
